import React from 'react';
import PrevIcon from 'static/images/icons/chevron-left.svg';
import NextIcon from 'static/images/icons/chevron-right.svg';
import { FormattedMessage } from 'react-intl';
import styles from '../../containers/Search/PatientSearchResults.css';

const Paginator = ({
  isLoading,
  onPageChange,
  currentPage,
  perPage,
  totalRecords,
  handleOnPagePress,
  className,
}) => {
  const pageCount = totalRecords ? Math.ceil(totalRecords / perPage) : 0;
  return (
    <div className={className || styles.resultPagination}>
      <button
        onClick={() => {
          onPageChange(currentPage - 1, 'click');
        }}
        className={styles.paginationPrevAction}
        type="button"
        disabled={currentPage === 1}
      >
        <PrevIcon />
        <span>
          <FormattedMessage id="search.SearchResults.Pagination.Button.Prev" />
        </span>
      </button>
      <div className={styles.pageNumber}>
        {pageCount !== 0 && (
          <React.Fragment>
            {currentPage > 2 && (
              <React.Fragment>
                {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
                <span
                  onClick={() => {
                    onPageChange(1, 'click');
                  }}
                  className={styles.firstPage}
                  role="button"
                  onKeyPress={() => {
                    if (handleOnPagePress) handleOnPagePress(1);
                  }}
                >
                  1
                </span>
                {' ... '}
              </React.Fragment>
            )}
            <span className={styles.currentPageNumber}>{currentPage}</span>
            <FormattedMessage
              id="search.SearchResults.Pagination.pageNumbers"
              values={{ totalPages: pageCount }}
            />
          </React.Fragment>
        )}
      </div>
      <button
        onClick={() => {
          onPageChange(currentPage + 1, 'click');
        }}
        className={styles.paginationNextAction}
        type="button"
        disabled={pageCount === 0 || currentPage === pageCount || isLoading}
      >
        <span>
          <FormattedMessage id="search.SearchResults.Pagination.Button.Next" />
        </span>
        <NextIcon />
      </button>
    </div>
  );
};
export default Paginator;



// WEBPACK FOOTER //
// ./src/views/components/Table/Paginator.jsx